<template>
  <div id="app">

    <router-view v-if="isRouterAlive"></router-view>

  </div>
</template>
<script>
export default {

  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
          color: #42b983;
      }
    }
  }
  .container {
    height: 100%;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .pb20{
    padding-bottom: 20px;
    line-height: 14px;
  }
  .p20{
    padding:20px;
  }
  .title.col-blue{
    color: #276CFF !important;
  }
  /*
    给所有表格空项加上--
  */
  .el-table .el-table__body td .cell:empty::after,
  .el-table .el-table__body td .cell > span:empty::after,
  .el-table .el-table__body td .cell .approval:empty::after,
  .el-table .el-table__body td .cell div:empty::after,
  .el-table .el-table__body td .cell .line-limit-length:empty::after{
    content: '--';
  }
  /*
    有的表格下面有个switch开关，里面有span，去掉--
  */
  .el-switch__core::after,.aroud_status_not::after{
    content: '' !important;
  }
</style>
